import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import products from '@/views/products'
import contactUs from '@/views/contactUs'
import aboutUs from '@/views/aboutUs'
import login from '@/views/login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/products',
      name: 'products',
      component: products,
      meta: {
        title: '产品和服务'
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs,
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '商户/代理商登录'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js